import { render, staticRenderFns } from "./companies-revenue-chart.vue?vue&type=template&id=c324aeee&scoped=true&"
import script from "./companies-revenue-chart.vue?vue&type=script&lang=js&"
export * from "./companies-revenue-chart.vue?vue&type=script&lang=js&"
import style0 from "./companies-revenue-chart.vue?vue&type=style&index=0&id=c324aeee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c324aeee",
  null
  
)

export default component.exports